<div class="container-fluid cards-container">
    @let kpi = kpis()[0];
    <div class="row g-3">
        <div class="col-sm-6 col-lg-3">
            <kpi-card
                [title]="texts.mvNetworksAverageAge.title"
                [body]="{
                    value: kpi.mvNetworksAverageAge,
                    suffix: texts.mvNetworksAverageAge.suffix,
                    precision: texts.mvNetworksAverageAge.precision,
                }"
                [badge]="{
                    value: kpi.mvNetworksAverageAgeEvolution,
                    suffix: texts.mvNetworksAverageAge.badgeSuffix,
                    precision: texts.mvNetworksAverageAge.badgePrecision,
                    style: kpi.mvNetworksAverageAgeEvolution! < 0 ? 'success' : 'danger',
                }"
                [descriptionTitle]="texts.mvNetworksAverageAge.descriptionTitle"
                [descriptionContent]="texts.mvNetworksAverageAge.descriptionContent"
                [isLoading]="!kpi.organizationId"
                [error]="checkKpiErrors(kpi, 'mvNetworksAverageAge')"
                cardClass="h-100">
            </kpi-card>
        </div>

        <div class="col-sm-6 col-lg-3">
            <kpi-card
                [title]="texts.mvNetworksLengthOver40YearsOld.title"
                [body]="{
                    value: kpi.mvNetworksLengthOver40YearsOld,
                    suffix: texts.mvNetworksLengthOver40YearsOld.suffix,
                    precision: texts.mvNetworksLengthOver40YearsOld.precision,
                }"
                [badge]="{
                    value: kpi.mvNetworksLengthOver40YearsOldEvolution,
                    suffix: texts.mvNetworksLengthOver40YearsOld.badgeSuffix,
                    precision: texts.mvNetworksLengthOver40YearsOld.badgePrecision,
                    style: kpi.mvNetworksLengthOver40YearsOldEvolution! < 0 ? 'success' : 'danger',
                }"
                [descriptionTitle]="texts.mvNetworksLengthOver40YearsOld.descriptionTitle"
                [descriptionContent]="texts.mvNetworksLengthOver40YearsOld.descriptionContent"
                [isLoading]="!kpi.organizationId"
                [error]="checkKpiErrors(kpi, 'mvNetworksLengthOver40YearsOld')"
                cardClass="h-100">
            </kpi-card>
        </div>

        <div class="col-sm-6 col-lg-3">
            <kpi-card
                [title]="texts.mvNetworksLengthCpi.title"
                [body]="{
                    value: kpi.mvNetworksLengthCpi,
                    suffix: texts.mvNetworksLengthCpi.suffix,
                    precision: texts.mvNetworksLengthCpi.precision,
                }"
                [badge]="{
                    value: kpi.mvNetworksLengthCpiEvolution,
                    suffix: texts.mvNetworksLengthCpi.badgeSuffix,
                    precision: texts.mvNetworksLengthCpi.badgePrecision,
                    style: kpi.mvNetworksLengthCpiEvolution! < 0 ? 'success' : 'danger',
                }"
                [descriptionTitle]="texts.mvNetworksLengthCpi.descriptionTitle"
                [descriptionContent]="texts.mvNetworksLengthCpi.descriptionContent"
                [isLoading]="!kpi.organizationId"
                [error]="checkKpiErrors(kpi, 'mvNetworksLengthOver40YearsOld')"
                cardClass="h-100">
            </kpi-card>
        </div>

        <div class="col-sm-6 col-lg-3">
            <kpi-card
                [title]="texts.mvNetworksLengthLowSection.title"
                [body]="{
                    value: kpi.mvNetworksLengthLowSection,
                    suffix: texts.mvNetworksLengthLowSection.suffix,
                    precision: texts.mvNetworksLengthLowSection.precision,
                }"
                [badge]="{
                    value: kpi.mvNetworksLengthLowSectionEvolution,
                    suffix: texts.mvNetworksLengthLowSection.badgeSuffix,
                    precision: texts.mvNetworksLengthLowSection.badgePrecision,
                    style: kpi.mvNetworksLengthLowSectionEvolution! < 0 ? 'success' : 'danger',
                }"
                [descriptionTitle]="texts.mvNetworksLengthLowSection.descriptionTitle"
                [descriptionContent]="texts.mvNetworksLengthLowSection.descriptionContent"
                [isLoading]="!kpi.organizationId"
                [error]="checkKpiErrors(kpi, 'mvNetworksLengthLowSection')"
                cardClass="h-100">
            </kpi-card>
        </div>
    </div>

    <chart-card
        id="mvNetworksAverageAge"
        [title]="texts.mvNetworksAverageAgesChart.title"
        [descriptionTitle]="texts.mvNetworksAverageAgesChart.descriptionTitle"
        [descriptionContent]="texts.mvNetworksAverageAgesChart.descriptionContent"
        [error]="averageAgesChartError"
        [isLoading]="!averageAgesChartDataSignal()[0].organizationId"
        [series]="averageAgesChartSeries"
        [dataLabels]="averageAgesChartDataLabels"
        [yaxis]="averageAgesChartYaxis"
        [precision]="texts.mvNetworksAverageAgesChart.precision"
        [xaxisTitle]="texts.mvNetworksAverageAgesChart.xaxisTitle"
        [grid]="averageAgesChartGrid"
        [unitTooltip]="texts.mvNetworksAverageAgesChart.unitTooltip"
        class="h-100"></chart-card>

    <chart-card
        id="mvNetworksAgeComparison"
        [title]="texts.mvNetworksAgesComparisonChart.title"
        [descriptionTitle]="texts.mvNetworksAgesComparisonChart.descriptionTitle"
        [descriptionContent]="texts.mvNetworksAgesComparisonChart.descriptionContent"
        [error]="agesComparisonChartError"
        [isLoading]="!agesComparisonChartDataSignal()[0].organizationId"
        [type]="'rangeBar'"
        [dataLabels]="comparisonDataLabels"
        [series]="agesComparisonChartSeries"
        [plotOptions]="agesComparisonPlotOptions"
        [customTooltip]="agesComparisonCustomTooltip"
        cardClass="h-100"></chart-card>

    <div class="row g-3">
        <div class="col-sm-12 col-lg-4">
            <chart-card
                id="mvNetworksLowSection"
                [title]="texts.mvNetworksLowSectionChart.title"
                [descriptionTitle]="texts.mvNetworksLowSectionChart.descriptionTitle"
                [descriptionContent]="texts.mvNetworksLowSectionChart.descriptionContent"
                [error]="lowSectionChartError"
                [isLoading]="!lowSectionChartDataSignal()[0].organizationId"
                [series]="lowSectionChartSeries"
                [dataLabels]="lowSectionChartDataLabels"
                [stacked]="true"
                [yaxis]="evolutionChartYaxis"
                [plotOptions]="evolutionPlotOptions"
                [xaxisTitle]="texts.mvNetworksLowSectionChart.xaxisTitle"
                [type]="'bar'"
                [grid]="evolutionChartGrid"
                [customTooltip]="lowSectionCustomTooltip"
                [legend]="lowSectionLegend"
                class="h-100">
            </chart-card>
        </div>
        <div class="col-sm-12 col-lg-4">
            <chart-card
                id="mvNetworksPaper"
                [title]="texts.mvNetworksPaperChart.title"
                [descriptionTitle]="texts.mvNetworksPaperChart.descriptionTitle"
                [descriptionContent]="texts.mvNetworksPaperChart.descriptionContent"
                [error]="paperChartError"
                [isLoading]="!paperChartDataSignal()[0].organizationId"
                [series]="paperChartSeries"
                [dataLabels]="paperChartDataLabels"
                [stacked]="true"
                [yaxis]="evolutionChartYaxis"
                [plotOptions]="evolutionPlotOptions"
                [type]="'bar'"
                [grid]="evolutionChartGrid"
                [xaxisTitle]="texts.mvNetworksPaperChart.xaxisTitle"
                [customTooltip]="paperCustomTooltip"
                [legend]="paperLegend"
                class="h-100">
            </chart-card>
        </div>
        <div class="col-sm-12 col-lg-4">
            <chart-card
                id="mvNetworksOver40"
                [title]="texts.mvNetworksOver40Chart.title"
                [descriptionTitle]="texts.mvNetworksOver40Chart.descriptionTitle"
                [descriptionContent]="texts.mvNetworksOver40Chart.descriptionContent"
                [error]="!!over40ChartDataSignal()[0].error"
                [isLoading]="!over40ChartDataSignal()[0].organizationId"
                [series]="over40ChartSeries"
                [dataLabels]="over40ChartDataLabels"
                [stacked]="true"
                [yaxis]="evolutionChartYaxis"
                [plotOptions]="evolutionPlotOptions"
                [type]="'bar'"
                [grid]="evolutionChartGrid"
                [xaxisTitle]="texts.mvNetworksOver40Chart.xaxisTitle"
                [customTooltip]="over40CustomTooltip"
                [legend]="over40Legend"
                class="h-100">
            </chart-card>
        </div>
    </div>

    <chart-card
        id="mvNetworksVigilancePoints"
        [title]="texts.mvNetworksVigilancePointsChart.title"
        [descriptionTitle]="texts.mvNetworksVigilancePointsChart.descriptionTitle"
        [descriptionContent]="texts.mvNetworksVigilancePointsChart.descriptionContent"
        [error]="vigilancePointsChartError"
        [isLoading]="!vigilancePointsChartDataSignal()[0].organizationId"
        [type]="'rangeBar'"
        [dataLabels]="comparisonDataLabels"
        [series]="vigilancePointsChartSeries"
        [plotOptions]="vigilancePointsPlotOptions"
        [customTooltip]="vigilancePointsCustomTooltip"
        cardClass="h-100"></chart-card>

    <geo-map-card
        [mapId]="'mvNetworksCpiLengthMap'"
        [title]="texts.mvNetworksCpiLengthMap.title"
        [descriptionContent]="texts.mvNetworksCpiLengthMap.descriptionContent"
        [descriptionTitle]="texts.mvNetworksCpiLengthMap.descriptionTitle"
        [geometries]="geometries()"
        [isLoading]="!geometries()[0].organizationId"
        [error]="!!geometries()[0].error"
        [getStyle]="getMapStyle"
        [legendConfig]="legendConfig"
        [getTooltip]="getTooltip"></geo-map-card>
</div>
